<template>
  <div class="printcontainer boxes">
    <h3><Icon type="md-bookmarks" />里程趋势分析<slot name="right"></slot></h3>

    <Row>
      <Col span="6">
        <ly-form-item label="累计里程：">{{ item.addMileage }}公里</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="日均里程：">{{ item.avgMileage }}公里</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="累计时长：">{{ item.addDuration }}小时</ly-form-item>
      </Col>
      <Col span="6">
        <ly-form-item label="日均时长：">{{ item.avgDuration }}小时</ly-form-item>
      </Col>
    </Row>
    <div id="lichengana"></div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      myData: [
        ["日常费用", "过桥费", "停车费", "代驾费", "年审费", "其他费"],
        [("粤A11111", 43, 85, 93, 24, 54)],
        ["粤A22222", 83, 73, 55, 43, 73],
        ["粤A33333", 86, 50, 80, 76, 24],
        ["粤A55555", 83, 73, 55, 43, 73],
        ["粤A66666", 86, 50, 80, 76, 24],
        ["粤A77777", 83, 73, 55, 43, 73],
        ["粤A88888", 83, 73, 55, 43, 73],
        ["粤A99999", 86, 50, 80, 76, 24],
        ["粤B22222", 83, 73, 55, 43, 73],
        ["粤C33333", 86, 50, 80, 76, 24],
      ],
      item: {
        addMileage: 0,
        avgMileage: 0,
        addDuration: 0,
        avgDuration: 0,
        dateList: [],
        addMileageList: [],
        avgMileageList: [],
        addDurationList: [],
        avgDurationList: [],
      },
    };
  },
  methods: {
    getData(v) {
      this.utils.loading(this, "加载中");
      this.axios({
        method: "post",
        url: this.axios.ipPort + "/cloud-car-server-oam/report/countMileage",
        data: v,
      }).then((res) => {
        this.$Spin.hide(); //关闭加载
        var data = res.data.data;

        var time = data.dateList;

        for (let j = 0; j < time.length; j++) {
          time[j] = this.utils.time(time[j], "mmdd");
        }
        this.item = data;
        this.drawBar();
      });
    },
    drawBar(id) {
      var that = this;
      this.chart = this.echarts.init(
        document.getElementById("lichengana"),
        "dark"
      );
      const colors = ["#41c733", "#2d8cf0", "#ef5a34", "#3fe0ee"];
      this.option = {
        color: colors,
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
          },
        },
        grid: {
          x: 100,
          y: 50,
          x2: 50,
          y2: 50, //距离下边的距离
        },
        toolbox: {
          /* feature: {
            dataView: { show: true, readOnly: false },
            restore: { show: true },
            saveAsImage: { show: true },
          }, */
        },
        legend: {
          data: ["总里程", "总时长", "日均里程", "日均时长"],
        },
        xAxis: [
          {
            type: "category",
            axisTick: {
              alignWithLabel: true,
            },
            // prettier-ignore
            data: this.item.dateList,
            axisLabel: { rotate: 45 },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "里程/km",
            position: "left",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[0],
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
          {
            type: "value",
            name: "时长/小时",
            position: "right",
            alignTicks: true,
            axisLine: {
              show: true,
              lineStyle: {
                color: colors[1],
              },
            },
            axisLabel: {
              formatter: "{value} ",
            },
          },
        ],
        series: [
          {
            name: "总里程",
            type: "bar",
            data: this.item.addMileageList,
            label: {
              show: true,
              position: "top",
            },
          },
          {
            name: "总时长",
            type: "bar",
            yAxisIndex: 1,
            data: this.item.addDurationList,
            label: {
              show: true,
              position: "top",
            },
          },
          {
            name: "日均里程",
            type: "line",
            data: this.item.avgMileageList,
          },
          {
            name: "日均时长",
            type: "line",
            yAxisIndex: 1,
            data: this.item.avgDurationList,
          },
        ],
      };
      this.chart.setOption(this.option);

      this.chart.resize();
    },
  },
  mounted() {
    this.drawBar();
  },
};
</script>
<style>
#lichengana {
  width: 100%;
  height: 500px;
  background: blue;
}
</style>


// WEBPACK FOOTER //
// src/components/dataAnalyse/anaReports/lichengfenxi.vue